export enum LocationType {
  Physical,
  Vehicle,
}
